import { useSelector } from 'react-redux';

import { RootState } from 'stores/store';
import { isCooperativeCompany } from 'core/services/cooperative';

/**
 * Cooperative societies use a reduced version of the platform: fixed share value, no treasury or
 * preferred shares, no capital operations or loyalty programs. Use `isCooperative` to hide these.
 */
const useCooperative = () => {
	const company = useSelector((state: RootState) => state.company);

	return { isCooperative: isCooperativeCompany(company) };
};

export default useCooperative;
